import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import { useFormikWizard } from "formik-wizard";

/* IMPORTANT!! Always import "setimmediate" on every step/first step*/
import 'setimmediate';




function AssetsOverAmount() {
  const { errors, touched, handleBlur, handleChange } = useFormikContext();
  return (
    <div id="results-overamount">
    <h2>As you have savings over £23,250 you may need to pay full costs of your care. </h2>
        <p>Many people arrange their own care at home. The <a href="https://find-information-for-adults-children-families.southglos.gov.uk/kb5/southglos/directory/adult.page?adultchannel=0&amp;channel=adult" target="_blank">South Gloucestershire Find information for adults, children and families</a> website has information about local services that can support you to live at home and be as independent as possible. For example; help with care (washing, dressing, toileting needs) and household tasks (cooking, cleaning, shopping). <a href="https://find-information-for-adults-children-families.southglos.gov.uk/kb5/southglos/directory/results.page?adultchannel=1-1&amp;channel=adult&amp;adv_sr=0" target="_blank">Equipment, adaptations and technology</a> can also help you to live at home more independently. </p>
        <p>If you have a long-term physical or mental illness or disability and are aged over 65 you may be able to get financial support with the <a href="https://www.gov.uk/attendance-allowance" target="_blank">Attendance Allowance.</a> </p>
 
    </div>
  );
}

export default AssetsOverAmount;
